// @ts-nocheck
import * as R from 'ramda';
import intl from 'react-intl-universal';
import React, { useCallback } from 'react';
import { FormattedMessage as T, FSelect, MenuItemNestedText } from '@/components';
import { ListSelect } from '@/components';
import { MenuItem } from '@blueprintjs/core';
import { saveInvoke } from '@/utils';
import classNames from 'classnames';
import { CLASSES } from '@/constants/classes';
import { DialogsName } from '@/constants/dialogs';
import withDialogActions from '@/containers/Dialog/withDialogActions';


// Create new account renderer.
const createNewItemRenderer = (query, active, handleClick) => {
  return (
    <MenuItem
      icon="add"
      text={intl.get('list.create', { value: `"${query}"` })}
      active={active}
      onClick={handleClick}
    />
  );
};

// Create new item from the given query string.
const createNewItemFromQuery = (name) => ({ name });

function CategoryListSelectRoot({
    // #withDialogActions
    openDialog,

    // #ownProps
    allowCreate,
  ...restProps
}) {
    // Maybe inject new item props to select component.
    const maybeCreateNewItemRenderer = allowCreate ? createNewItemRenderer : null;
    const maybeCreateNewItemFromQuery = allowCreate
      ? createNewItemFromQuery
      : null;
  
    // Handles the create item click.
    const handleCreateItemClick = () => {
      openDialog(DialogsName.ItemCategoryForm);
    };


  return (
    <FSelect
    valueAccessor={'id'}
    //labelAccessor={'name'}
    textAccessor={'name'}
    popoverProps={{ minimal: true, usePortal: true, inline: false }}
    createNewItemRenderer={maybeCreateNewItemRenderer}
    createNewItemFromQuery={maybeCreateNewItemFromQuery}
    onCreateItemSelect={handleCreateItemClick}
    
    {...restProps}
  />
    // <ListSelect
    //   items={categories}
    //   selectedItemProp={'id'}
    //   selectedItem={selecetedCategoryId}
    //   textProp={'name'}
    //   defaultText={defaultSelectText}
    //   onItemSelect={handleItemCategorySelected}
    //   itemPredicate={filterItemCategory}
    //   itemRenderer={categoryItem}
    //   createNewItemRenderer={maybeCreateNewItemRenderer}
    //   createNewItemFromQuery={maybeCreateNewItemFromQuery}
    //   onCreateItemSelect={handleCreateItemClick}
    //   popoverProps={{ minimal: true, usePortal: true, inline: false }}
    //   className={classNames(
    //     'form-group--select-list',
    //     {
    //       [CLASSES.SELECT_LIST_FILL_POPOVER]: popoverFill,
    //     },
    //     className,
    //   )}
    //   {...restProps}
    // />
  );
}


export const CategoriesSelectList = R.compose(withDialogActions)(CategoryListSelectRoot);